export const TEMPLATE_TYPES = ['AMA', 'API_INTEGRATION'] as const

export type TemplateType = (typeof TEMPLATE_TYPES)[number]

export const TEMPLATE_TYPE_LABELS: Record<TemplateType, string> = {
  AMA: 'AMA',
  API_INTEGRATION: 'API Integration',
}

export function isTemplateType(value: unknown): value is TemplateType {
  return (
    typeof value === 'string' &&
    (TEMPLATE_TYPES as readonly string[]).includes(value)
  )
}
